import { render, staticRenderFns } from "./DispatchedOrder.vue?vue&type=template&id=66de77de&scoped=true"
import script from "./DispatchedOrder.vue?vue&type=script&lang=js"
export * from "./DispatchedOrder.vue?vue&type=script&lang=js"
import style0 from "./DispatchedOrder.vue?vue&type=style&index=0&id=66de77de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66de77de",
  null
  
)

export default component.exports